import React from "react";

import Skeleton from "react-loading-skeleton";

import * as Styled from "./skeleton-expert-review.styled";

export const SkeletonExpertReview = () => {
  return (
    <Styled.ExpertReviewSkeleton>
      <Styled.ExpertReviewColumn>
        <Skeleton style={{ paddingBottom: "56.25%" }} />
      </Styled.ExpertReviewColumn>
      <Styled.ExpertReviewColumn>
        <Skeleton style={{ height: "40px" }} />
        <Skeleton
          style={{ height: "40px", width: "150px", marginTop: "24px" }}
        />
        <Skeleton style={{ height: "20px", marginTop: "24px" }} />
        <Skeleton style={{ height: "20px", marginTop: "24px" }} />
        <Skeleton
          style={{ height: "60px", width: "350px", marginTop: "24px" }}
        />
      </Styled.ExpertReviewColumn>
    </Styled.ExpertReviewSkeleton>
  );
};
